import { render } from "./Dialog.vue?vue&type=template&id=587b6e4b&scoped=true&ts=true"
import script from "./Dialog.vue?vue&type=script&lang=ts"
export * from "./Dialog.vue?vue&type=script&lang=ts"

import "./Dialog.vue?vue&type=style&index=0&id=587b6e4b&scoped=true&lang=scss"
import "./Dialog.vue?vue&type=style&index=1&id=587b6e4b&scoped=true&lang=scss"
import "./Dialog.vue?vue&type=style&index=2&id=587b6e4b&scoped=true&lang=scss"
import "./Dialog.vue?vue&type=style&index=3&id=587b6e4b&scoped=true&lang=scss"

import exportComponent from "/home/travis/build/indochat/official-website/www.ecomm-cloud.net/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-587b6e4b"]])

export default __exports__